import React from 'react';

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import InputAdornment from '@mui/material/InputAdornment';

// Icons
import RemoveIcon from '@mui/icons-material/Remove';
import FilterListIcon from '@mui/icons-material/FilterList';

// Components
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomActionBar from '../../../components/CustomActionBarDatePicker';
import dayjs from 'dayjs';
import Dropdown from "../../../components/inputs/dropdown";
import Searchbox from "../../../components/inputs/searchbox";
import Autocomplete from "../../../components/inputs/Autocomplete";

// Models
import { statesFilter, typesFilter, subTypesFilter, suggestedReasons } from "../../../models/MovementEntity";

const MovementFilters = ({ filters, setFilters, clearFilters }) => {
    const handleFilterChange = (event) =>
        setFilters({ [event.target.name]: event.target.value });

    return (
        <Box component={Paper} padding={2}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 9
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por movimiento: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 2
                            }}
                        >
                            <Searchbox
                                fullWidth
                                name='movementIds'
                                label='Movimiento'
                                onChange={handleFilterChange}
                                size='small'
                                value={filters?.movementIds || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 3
                            }}
                        >
                            <Autocomplete
                                fullWidth
                                freeSolo
                                size='small'
                                name='reason'
                                options={suggestedReasons}
                                getOptionLabel={(option) => option}
                                onChange={handleFilterChange}
                                value={filters?.reason || ''}
                                TextProps={{
                                    placeholder: 'Motivo',
                                    name: 'reason',
                                }}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 2
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='type'
                                onChange={handleFilterChange}
                                size='small'
                                label="Tipo de movimiento"
                                getOptionLabel={(option) => option?.label}
                                getOptionValue={(option) => option?.value}
                                value={filters?.type || ''}
                                values={[{ value: 'all', label: 'Todos' }, ...typesFilter]}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 2
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='subType'
                                onChange={handleFilterChange}
                                size='small'
                                label="Sub Tipo"
                                getOptionLabel={(option) => option?.label}
                                getOptionValue={(option) => option?.value}
                                value={filters?.subType || ''}
                                values={[{ value: 'all', label: 'Todos' }, ...subTypesFilter]}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 3
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='state'
                                label='Estado'
                                onChange={handleFilterChange}
                                size='small'
                                getOptionLabel={(option) => option?.label}
                                getOptionValue={(option) => option?.value}
                                value={filters?.state || ''}
                                values={[{ value: 'all', label: 'Todos' }, ...statesFilter]}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por Fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >

                            <DatePicker
                                label={filters?.from ? 'Desde' : 'dd/mm/aaaa'}
                                value={filters?.from ? dayjs(filters.from) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'from',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                        }
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'from',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <DatePicker
                                label={filters?.to ? 'Hasta' : 'dd/mm/aaaa'}
                                value={filters?.to ? dayjs(filters.to) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'to',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                        }
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'to',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por Remito: </Typography>
                        </Grid>
                        <Grid size={4}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='referralId'
                                label='Remito'
                                onChange={handleFilterChange}
                                value={filters?.referralId || ''}
                            />
                        </Grid>
                        <Grid size={8}>
                            <Searchbox
                                fullWidth
                                name='shipmentNumber'
                                label='Nro Envio'
                                onChange={handleFilterChange}
                                size='small'
                                value={filters?.shipmentNumber || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por Comprob Externo: </Typography>
                        </Grid>
                        <Grid size={4}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='prefixTicket'
                                label='Prefijo'
                                onChange={handleFilterChange}
                                value={filters?.prefixTicket || ''}
                                InputProps={
                                    {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <RemoveIcon />
                                            </InputAdornment>
                                        )
                                    }
                                }
                            />
                        </Grid>
                        <Grid size={8}>
                            <Searchbox
                                fullWidth
                                name='numberTicket'
                                label='Numero'
                                onChange={handleFilterChange}
                                size='small'
                                value={filters?.numberTicket || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Box component={Grid} item display='flex' flexGrow={1} alignItems='flex-end' justifyContent='flex-end'>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Box>
            </Grid>
        </Box>
    );
}

export default MovementFilters;